export enum Languages {
  PT_BR = 'pt-BR',
  EN_US = 'en-US',
}
